import type {RecipeCostReport} from "../../../shared/production/recipe-cost";
export const format = (value: number, precision = 4) => new Intl.NumberFormat("tr-TR", { maximumFractionDigits: precision }).format(value);
export const money = (value: number) => new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(value);

export const recipeKindValid = (kind: string) => /^\d{1,3}$/u.test(kind) && Number(kind) <= 255;
export function recipeCostSummary(report: RecipeCostReport | null) {
  const piece = report?.unitCosts.find(unit => unit.unit.trim().toLocaleUpperCase("tr-TR") === "ADET");
  const uniqueIssues = report ? [...new Map(report.issues.map(issue => [`${issue.code}/${issue.kind}/${issue.message}`, issue])).values()] : [];
  return {piece, uniqueIssues};
}
